var NAMESPACE = 'td';

var Collapse = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-collapse" }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-collapse',

  model: {
    prop: 'value',
    event: 'change'
  },

  provide: function provide() {
    return {
      collapse: this
    };
  },


  props: {
    value: [Number, String]
  },

  created: function created() {
    var _this = this;

    this.$on('item-change', function (value) {
      _this.$emit('change', value);
    });
  }
};

var CollapseItem = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-collapse-item", class: { 'is-active': _vm.active } }, [_c('div', { staticClass: "td-collapse-item__title", on: { "click": _vm.handleTitleClick } }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('div', { staticClass: "td-collapse-item__content" }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-collapse-item',

  inject: ['collapse'],

  props: {
    title: [Number, String],
    value: [Number, String]
  },

  computed: {
    active: function active() {
      return this.value === this.collapse.value;
    }
  },

  methods: {
    handleTitleClick: function handleTitleClick() {
      this.collapse.$emit('item-change', this.value);
    }
  }
};

Collapse.install = function (Vue) {
  Vue.component(Collapse.name, Collapse);
  Vue.component(CollapseItem.name, CollapseItem);
};

export default Collapse;
export { CollapseItem };
